import {buildCommonEditorActionTypes} from "./commonEditorATBuider";
import {buildCommonGridActionTypes} from "./commonGridATBuilder";


export const PRODUCTS_GRID = buildCommonGridActionTypes('PRODUCTS');

export const PRODUCT_EDITOR = buildCommonEditorActionTypes('PRODUCT');
